import ResumeCard from './ResumeCard';
import ResumeCard2 from './ResumeCard2';
import { motion } from 'framer-motion';
const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className='w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20 mt-5 px-5'
    >
      <div className='w-full mdl:w-1/2 '>
        <div className='py-6 px-5 lgl:py-12 font-titleFont flex flex-col gap-4 text-center'>
          <p className='text-sm text-designColor tracking-[4px]'> 2012-2025</p>
          <h2 className='text-3xl md:text-4xl font-bold'>Leadership Quality</h2>
        </div>
        <div className='h-[1300px]'>
        <div className='mt-6 lgl:mt-14  w-full h-[900px] border-l-[6px] border-l-black border-opacity-30  flex flex-col gap-10'>
          <ResumeCard
            title='Senior Prefect'
            subTitle='Fountain International High School (2016-2017)'
            des='Headed the school student body for a duration of 1 year'
            location='PortHarcourt'
          />
          <ResumeCard
            title='Member of Class Excos'
            subTitle='University of Nigeria, Nsukka (2020-2024)'
            des='Was an active member of the class executives, assisting the class representative'
            location='Enugu'
          />
          <ResumeCard
            title='Instructor'
            subTitle='Church and School social activities'
            des='Been in-charge of directing some of the affairs in school and in church'
            location='Lagos'
          />
        </div>
        </div>
      </div>
      <div className='w-full h-[700px] mdl:w-1/2'>
        <div className='py-6 lgl:py-12 font-titleFont flex flex-col gap-4 text-center'>
          <p className='text-sm text-designColor tracking-[4px]  '>
            {' '}
            2023-Present
          </p>
          <h2 className='text-3xl md:text-4xl font-bold'>Work Experience</h2>
        </div>

        <div className='mt-6 lgl:mt-14  w-full h-[1300px] border-l-[6px] border-l-black border-opacity-30  flex flex-col gap-10'>
          <ResumeCard
            title='Business Development Officer'
            subTitle='Easylife Preparation Ltd (2025-Present)'
            des='Supported international student recruitment and study abroad services by guiding clients through admission processes, visa applications, and flight bookings. Promoted partnerships with educational institutions and ensured smooth coordination from application to travel.'
            location='Rivers'
          />
          <ResumeCard
            title='Software/Web Developer (Remote)'
            subTitle='Arone Technologies (2023-Present)'
            des='Full Stack Web Developer skilled in building responsive web applications using React.js and Flask/Nodejs, with experience in API development, database integration, and cloud deployment. Focused on creating secure, scalable, and user-friendly solutions.'
            location='Enugu'
          />
          <ResumeCard
            title='Front End Developer Intern'
            subTitle='ICT Centre, UNN (2023)'
            des='Currently working as an IT student at an ICT centre. Currently working with other front and back end developers to build awesome projects'
            location='Enugu'
          />
          <ResumeCard
            title='Networking Intern'
            subTile='Data Centre, UNN'
            des='worked for a few weeks as an intern at Data centre. '
            location='Enugu'
          />
        </div>
      </div>
    </motion.div>
  );
};
export default Experience;
